import i18n from 'modules/core/lib/i18n'

const getPlanLabel = (plan: string): string => {
  switch (plan) {
    case 'ats_limited':
      return i18n.t('billing.plans.ats_limited.title')
    case 'ats_promo_migration':
      return i18n.t('billing.plans.ats_promo_migration.title')
    case 'ats_promo_pro_migration':
      return i18n.t('billing.plans.ats_promo_pro_migration.title')
    case 'ats_unlimited':
      return i18n.t('billing.plans.ats_unlimited.title')
    case 'basic':
      return i18n.t('billing.plans.basic.title')
    case 'business_base':
      return i18n.t('billing.plans.business_base.title')
    case 'business_talent':
      return i18n.t('billing.plans.business_talent.title')
    case 'business_talent_only':
      return i18n.t('billing.plans.business_talent_only.title')
    case 'certification':
      return i18n.t('billing.plans.certification.title')
    case 'enterprise':
      return i18n.t('billing.plans.enterprise.title')
    case 'enterprise_base':
      return i18n.t('billing.plans.enterprise_base.title')
    case 'enterprise_talent':
      return i18n.t('billing.plans.enterprise_talent.title')
    case 'enterprise_talent_only':
      return i18n.t('billing.plans.enterprise_talent_only.title')
    case 'essentials':
      return i18n.t('billing.plans.essentials.title')
    case 'free':
      return i18n.t('billing.plans.free.title')
    case 'hr':
      return i18n.t('billing.plans.hr.title')
    case 'legal':
      return i18n.t('billing.plans.legal.title')
    case 'none':
      return i18n.t('billing.plans.none.title')
    case 'payroll':
      return i18n.t('billing.plans.payroll.title')
    case 'premium':
      return i18n.t('billing.plans.premium.title')
    default:
      return plan
  }
}

export default getPlanLabel
